// extracted by mini-css-extract-plugin
export default {"chevronIcon":"Icons_chevronIcon__1D6xa"};